import React, { useState } from "react";
import { useScroll, useMotionValueEvent, motion } from "framer-motion";
import { Sunrise, Sun, Sunset, Moon } from "lucide-react";

const PHASES = [
  { key: "dawn", label: "Dawn", time: "6:12 AM", icon: Sunrise, upto: 0.12 },
  { key: "day", label: "Midday", time: "1:30 PM", icon: Sun, upto: 0.30 },
  { key: "dusk", label: "Golden Hour", time: "7:45 PM", icon: Sunset, upto: 0.58 },
  { key: "night", label: "Nightfall", time: "10:20 PM", icon: Moon, upto: 1.01 },
];

// Fixed side indicator that reflects the "time of day" as you scroll.
export default function DayIndicator() {
  const { scrollYProgress } = useScroll();
  const [idx, setIdx] = useState(0);
  const [dark, setDark] = useState(false);

  useMotionValueEvent(scrollYProgress, "change", (v) => {
    const i = PHASES.findIndex((p) => v < p.upto);
    setIdx(i === -1 ? PHASES.length - 1 : i);
    setDark(v > 0.56);
  });

  const Phase = PHASES[idx];
  const Icon = Phase.icon;
  const tone = dark ? "#F4ECE0" : "#201A17";

  return (
    <div className="hidden md:flex fixed right-6 top-1/2 -translate-y-1/2 z-[60] flex-col items-center gap-4">
      <div className="flex flex-col items-center gap-2">
        {PHASES.map((p, i) => (
          <div key={p.key} className="relative">
            <motion.span
              className="block w-2.5 h-2.5 rounded-full"
              animate={{
                backgroundColor: i === idx ? "var(--terracotta)" : "transparent",
                borderColor: tone,
                scale: i === idx ? 1.3 : 1,
              }}
              style={{ border: `1.5px solid ${tone}` }}
            />
          </div>
        ))}
      </div>
      <motion.div
        key={Phase.key}
        initial={{ opacity: 0, y: 8 }}
        animate={{ opacity: 1, y: 0 }}
        className="flex flex-col items-center gap-1"
        style={{ color: tone }}
      >
        <Icon size={20} className="text-terra" />
        <span className="font-display font-bold text-[11px] tracking-wide [writing-mode:vertical-rl] rotate-180">{Phase.label}</span>
        <span className="font-body text-[10px] opacity-60 [writing-mode:vertical-rl] rotate-180">{Phase.time}</span>
      </motion.div>
    </div>
  );
}
